import {createContext} from 'react'

export const ItemBagContext = createContext({})
